/** User-facing copy when speaking submission or grading fails (Speaking practice inline error). */
export const SPEAKING_SUBMIT_FAILED_USER_MESSAGE =
  'Mohon maaf, submission speaking gagal dilakukan. Anda dapat mencoba kembali atau merekam ulang.';

/** Shown after final speaking grading poll still returns HTTP 500 (retry already used). */
export const SPEAKING_GRADING_POLL_500_EXHAUSTED_FOOTER =
  'Mohon maaf penilaian gagal, silahkan kembali ke halaman course.';

/** First poll-500 screen body when API does not return a message. */
export const SPEAKING_GRADING_POLL_500_FIRST_FALLBACK =
  'Mohon maaf, penilaian gagal dilakukan. Anda dapat mencoba refresh.';
